/* Sipprint — custom scripts (vanilla, no dependencies) */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.sp-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add('sp-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sp-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHero() {
    document.querySelectorAll('[data-sp-hero]').forEach(function (hero) {
      var swatches = hero.querySelectorAll('[data-sp-swatch]');
      var imgs = hero.querySelectorAll('[data-sp-hero-img]');
      var links = hero.querySelectorAll('[data-sp-hero-link]');
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          var key = sw.getAttribute('data-sp-swatch');
          swatches.forEach(function (s) {
            var on = s === sw;
            s.classList.toggle('is-active', on);
            s.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          imgs.forEach(function (img) {
            img.classList.toggle('is-active', img.getAttribute('data-sp-hero-img') === key);
          });
          var url = sw.getAttribute('data-url');
          if (url) links.forEach(function (a) { a.setAttribute('href', url); });
        });
      });
    });
  }

  function initProduct() {
    document.querySelectorAll('[data-sp-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-sp-variants]');
      var main = root.querySelector('[data-sp-main]');
      var thumbs = root.querySelectorAll('[data-sp-thumb]');

      function showMedia(id) {
        var t = root.querySelector('[data-sp-thumb="' + id + '"]');
        if (!t || !main) return;
        main.src = t.getAttribute('data-full');
        main.removeAttribute('srcset');
        main.alt = t.getAttribute('data-alt') || '';
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { showMedia(t.getAttribute('data-sp-thumb')); });
      });

      if (!dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-sp-price]');
      var compareEl = root.querySelector('[data-sp-compare]');
      var btn = root.querySelector('[data-sp-add]');
      var btnLabel = root.querySelector('[data-sp-add-label]');
      var groups = root.querySelectorAll('[data-sp-option]');

      function update(pushState) {
        var chosen = [];
        groups.forEach(function (g) {
          var c = g.querySelector('input:checked');
          chosen.push(c ? c.value : null);
          var out = g.querySelector('[data-sp-option-value]');
          if (out && c) out.textContent = c.value;
        });
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return o === chosen[i]; });
        })[0];
        if (!btn) return;
        if (!v) {
          btn.disabled = true;
          if (btnLabel) btnLabel.textContent = btn.getAttribute('data-unavailable');
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price;
        if (compareEl) {
          compareEl.textContent = v.compare || '';
          compareEl.hidden = !v.compare;
        }
        btn.disabled = !v.available;
        if (btnLabel) btnLabel.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
        if (v.media) showMedia(v.media);
        if (pushState && window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      groups.forEach(function (g) {
        g.addEventListener('change', function () { update(true); });
      });
    });
  }

  function init() {
    document.documentElement.classList.remove('sp-no-js');
    initReveal();
    initHero();
    initProduct();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
